"use client"

import ArrowBack from "@/assets/vectors/ArrowBack"
import Button from "@/components/button/Button"
import { motion } from "motion/react"
import styles from "./not_found.module.scss"

const floatingConfigs = [
    { y: [0, -14, 0], duration: 4.5, delay: 0 },
    { y: [0, 10, 0], duration: 3.8, delay: 0.6 },
    { y: [0, -12, 0], duration: 5.2, delay: 1.2 },
]

export default function NotFound() {
    return (
        <main className={styles.page} id="main-content">
            <svg style={{ position: "absolute", width: 0, height: 0 }} aria-hidden="true">
                <filter id="cosmic-warp">
                    <feTurbulence
                        type="fractalNoise"
                        baseFrequency="0.015"
                        numOctaves="3"
                        result="noise"
                    />
                    <feDisplacementMap
                        in="SourceGraphic"
                        in2="noise"
                        scale="18"
                        xChannelSelector="R"
                        yChannelSelector="G"
                    />
                </filter>
            </svg>

            <div className={styles.pattern} />
            <div className={styles.gradient_bg} />
            <div className={styles.stars} />

            <div className={styles.content}>
                <div className={styles.badge}>
                    <span className={styles.pulse} />
                    EVENT HORIZON // 404
                </div>

                <div className={styles.digits}>
                    {[4, 0, 4].map((digit, i) => (
                        <motion.span
                            key={i}
                            className={styles.digit}
                            animate={{ y: floatingConfigs[i].y }}
                            transition={{
                                duration: floatingConfigs[i].duration,
                                repeat: Infinity,
                                ease: "easeInOut",
                                delay: floatingConfigs[i].delay,
                            }}
                        >
                            {digit}
                        </motion.span>
                    ))}
                </div>

                <p className={styles.message}>
                    You&apos;ve ventured beyond the <strong>event horizon</strong>.
                    <br />
                    Nothing exists past this point — not even this page.
                </p>

                <p className={styles.subtext}>Error 404 · Lost Transmission</p>

                <div className={styles.cta}>
                    <Button label="Navigate Home" href="/" startIcon={ArrowBack} />
                </div>
            </div>
        </main>
    )
}
